import type { MissionConfig } from '../../data/missions';
import { missionSwapCost } from '../../domain/chipUtils';

interface MissionSwapConfirmDialogProps {
  open: boolean;
  draftTurn: number;
  currentMission: MissionConfig;
  newMission: MissionConfig;
  betAmount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

function MissionSummary({ label, mission }: { label: string; mission: MissionConfig }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-3">
      <p className="text-[10px] font-medium uppercase tracking-wide text-white/45">{label}</p>
      <p className="mt-1 text-sm font-semibold text-amber-100">{mission.name}</p>
      <p className="mt-1 line-clamp-2 text-xs text-white/65">{mission.description}</p>
      <p className="mt-2 text-xs font-semibold text-amber-300">배당 ×{mission.payout}</p>
    </div>
  );
}

export function MissionSwapConfirmDialog({
  open,
  draftTurn,
  currentMission,
  newMission,
  betAmount,
  onConfirm,
  onCancel,
}: MissionSwapConfirmDialogProps) {
  if (!open) return null;

  const cost = missionSwapCost(draftTurn);
  const betAfterSwap = betAmount - cost;

  return (
    <div
      className="pointer-events-auto fixed inset-0 z-30 flex items-center justify-center bg-black/50 p-4"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="overlay-panel w-full max-w-md rounded-2xl p-4"
        role="dialog"
        aria-label="미션 카드 교체 확인"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-sm font-semibold text-amber-100">미션 카드 교체</h2>
        <p className="mt-1 text-xs text-white/65">
          아래 미션으로 교체합니다. 교체 비용 {cost}점이 베팅 칩에서 차감됩니다.
        </p>

        <div className="mt-4 space-y-2">
          <MissionSummary label="현재 미션" mission={currentMission} />
          <p className="text-center text-xs text-white/50">↓</p>
          <MissionSummary label="교체할 미션" mission={newMission} />
        </div>

        <div className="mt-4 rounded-xl border border-amber-400/30 bg-amber-400/5 p-3 text-xs text-white/80">
          <p>교체 비용: {cost}점 (하우스로 이동)</p>
          <p className="mt-1">교체 후 베팅 칩: {betAfterSwap}점</p>
        </div>

        <div className="mt-4 flex gap-2">
          <button
            type="button"
            className="overlay-button-ghost min-h-[44px] flex-1"
            onClick={onCancel}
          >
            취소
          </button>
          <button
            type="button"
            className="overlay-button-primary min-h-[44px] flex-1"
            onClick={onConfirm}
          >
            교체하기
          </button>
        </div>
      </div>
    </div>
  );
}
